<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div class="text-center menu-container">
        <h2 class="heading01">Legameオリジナル食事Book</h2>
        <Book></Book>
        <a href="/static/mealbook.pdf" class="btn btn-primary mt-2" target="_blank">PDF版をダウンロード</a>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Book from './Book.vue'

export default {
  name: 'MealBook',
  components: {
    Header,
    Footer,
    Book
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MealBook.vue